import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    FormControlLabel,
    Checkbox,
    Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: (sendEmail: boolean) => Promise<void>;
    isEnabling: boolean; // true = udostępnianie testu, false = ukrywanie testu
    serviceName: string;
    userEmail: string;
}

export default function TestAvailabilityConfirmDialog({
    open,
    onClose,
    onConfirm,
    isEnabling,
    serviceName,
    userEmail
}: Props) {
    const [sendEmail, setSendEmail] = useState(true);
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await onConfirm(sendEmail);
        } finally {
            setLoading(false);
            setSendEmail(true); // Reset do domyślnej wartości
        }
    };

    const handleClose = () => {
        if (!loading) {
            setSendEmail(true); // Reset do domyślnej wartości
            onClose();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="test-availability-dialog-title"
            aria-describedby="test-availability-dialog-description"
        >
            <DialogTitle id="test-availability-dialog-title">
                {isEnabling ? 'Udostępnienie testu' : 'Ukrycie testu'}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="test-availability-dialog-description" component="div">
                    {isEnabling ? (
                        <>
                            <p>
                                Czy na pewno chcesz <strong>udostępnić test</strong> dla zamówienia
                                na usługę <strong>"{serviceName}"</strong>?
                            </p>
                            <p>
                                Klient (<strong>{userEmail}</strong>) otrzyma dostęp do testu
                                egzaminacyjnego.
                            </p>
                        </>
                    ) : (
                        <>
                            <p>
                                Czy na pewno chcesz <strong>ukryć test</strong> dla zamówienia
                                na usługę <strong>"{serviceName}"</strong>?
                            </p>
                            <p>
                                Klient (<strong>{userEmail}</strong>) straci dostęp do testu
                                egzaminacyjnego.
                            </p>
                        </>
                    )}
                </DialogContentText>
                
                {isEnabling && (
                    <Box sx={{ mt: 2 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={sendEmail}
                                    onChange={(e) => setSendEmail(e.target.checked)}
                                    color="primary"
                                />
                            }
                            label="Wyślij powiadomienie e-mail do klienta o udostępnieniu testu"
                        />
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit" disabled={loading}>
                    Anuluj
                </Button>
                <LoadingButton
                    onClick={handleConfirm}
                    color={isEnabling ? 'primary' : 'warning'}
                    loading={loading}
                    autoFocus
                >
                    {isEnabling ? 'Udostępnij test' : 'Ukryj test'}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
